import PropTypes from 'prop-types'
import { Table } from 'reactstrap'


const propTypes = {
  inventoryLocations : PropTypes.array,
  tableProps         : PropTypes.object,
  className          : PropTypes.string
}

const defaultProps = {
  inventoryLocations: []
}

/**
 * @param {Array<Object>} data - array of inventory location objects
 */
const InventoryLocationTable = ({ inventoryLocations, className, tableProps }) => (
  <Table
    bordered
    size='sm'
    { ...tableProps }
    className={ className }
  >
    <thead>
      <tr>
        <th>ID</th>
        <th>Lokasi</th>
        <th>Sub Lokasi</th>
        <th>Kuantitas</th>
      </tr>
    </thead>
    <tbody>
      {
        inventoryLocations.map((invLocation) => (
          <tr key={ `inv-location-table-row-${invLocation.id}` }>
            <td>{ invLocation.location_id }</td>
            <td>{ invLocation.location }</td>
            <td>{ invLocation.sublocation }</td>
            <td>{ invLocation.quantity }</td>
          </tr>
        ))
      }
    </tbody>
  </Table>
)

InventoryLocationTable.propTypes    = propTypes
InventoryLocationTable.defaultProps = defaultProps

export default InventoryLocationTable